"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
var AXSLoader_1 = __importDefault(require("../../elements/AXSLoader"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Loading = styled_components_1.default(AXSLoader_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 22px;\n    height: 22px;\n    position: absolute;\n    top: 15px;\n    right: 5px;\n    z-index: 1;\n"], ["\n    width: 22px;\n    height: 22px;\n    position: absolute;\n    top: 15px;\n    right: 5px;\n    z-index: 1;\n"])));
var Loader = function (isFetching) { return isFetching ?
    React.createElement(Loading, { size: "10px", width: "18px", height: "18px", active: isFetching }) : null; };
exports.Loader = Loader;
var templateObject_1;
//# sourceMappingURL=Loader.js.map